import { useState, useRef } from "react";
import { Image, Swiper } from 'antd-mobile';
import './reward-rules.less'
import { SwiperRef } from 'antd-mobile/es/components/swiper'
import { useLocation } from 'react-router-dom'
// 图片
import weekRewardWall from '@/image/invite/reward-rules/week_reward_wall.png'
import monthRewardWall from '@/image/invite/reward-rules/month_reward_wall.png'
import ruleDescription from '@/image/invite/reward-rules/rule_description.png'
import week_rank_reward from '@/image/invite/reward-rules/week_rank_reward.png'
import active_week_rank_reward from '@/image/invite/reward-rules/active_week_rank_reward.png'
import month_rank_reward from '@/image/invite/reward-rules/month_rank_reward.png'
import active_month_rank_reward from '@/image/invite/reward-rules/active_month_rank_reward.png'
import rule_instr_btn from '@/image/invite/reward-rules/rule_instr_btn.png'
import active_rule_instr_btn from '@/image/invite/reward-rules/active_rule_instr_btn.png'

const RewardRules = (props:any) => {
  const swiperRef = useRef<SwiperRef>(null)
  const [currentNav, setCurrentNav] = useState<number>(1)
  const { pathname } = useLocation()

  const navTo = (index:number) => {
    swiperRef.current?.swipeTo(index)
    setCurrentNav(index)
  }

  return (
    <section className={"reward-rules " + (pathname.includes('/active/') ? 'hidden-top' : '')}>
      <nav className='btns'>
        <Image src={currentNav === 0 ? active_week_rank_reward : week_rank_reward} fit='contain' onClick={() => navTo(0)} />
        <Image src={currentNav === 1 ? active_month_rank_reward : month_rank_reward} fit='contain' onClick={() => navTo(1)} />
        <Image src={currentNav === 2 ? active_rule_instr_btn : rule_instr_btn} fit='contain' onClick={() => navTo(2)} />
      </nav>

      <Swiper
        direction='horizontal'
        indicator={() => null}
        ref={swiperRef}
        defaultIndex={currentNav}
        onIndexChange={index => {
          setCurrentNav(index)
        }}
      >
        <Swiper.Item>
          <Image src={weekRewardWall} fit='contain' />
        </Swiper.Item>
        <Swiper.Item>
          <Image src={monthRewardWall} fit='contain' />
        </Swiper.Item>
        <Swiper.Item>
          <Image src={ruleDescription} fit='contain' />
        </Swiper.Item>
      </Swiper>

      {/* <div className="content">
        <Image src={currentNav === 1 ? weekRewardWall : currentNav === 2 ? monthRewardWall : ruleDescription} fit='contain' />
      </div> */}
    </section>
  )
}

export default RewardRules